<div class="batch-list-row-wrapper" [class.disabled]="isTPL">
  <div
    class="batch-list-row"
    [class.disabled]="isTPL"
    [class.secondary]="variant === 'secondary'"
    (click)="setActiveBatch($event)">
    <div class="batch-list-row__left-border border"></div>

    <!-- BACK TO ASSIGN BUTTON -->
    @if (variant !== 'secondary' && canBeMovedBackToASsign) {
      <div class="batch-list-row__back" (click)="$event.stopPropagation()">
        <fulfill-back-to-assign-btn class="action-btn" [batch]="batch"></fulfill-back-to-assign-btn>
      </div>
    }

    <!-- BATCH NAME -->
    <div class="batch-list-row__name customizable">
      {{ batch.name }}
      @if (isTPL) {
        <pdq-tag value="3PL" mode="rect" [style]="{ marginLeft: '4px' }"></pdq-tag>
      }
      @if (batch?.isTestMode) {
        <pdq-tag mode="rect" [style]="{ marginLeft: '4px' }">Test Mode</pdq-tag>
      }
      @if (batch.updated) {
        <img src="../../../../../../assets/icons/pay_attention.png" />
      }
      @if (hasAddedOrders) {
        <img src="../../../../../../assets/icons/added-to-batch-icon.svg" [style]="{ marginLeft: '4px' }" />
      }
    </div>

    <!-- BATCH DETAILS -->
    <div class="batch-list-row__packages customizable">
      <span>{{ batch.orders.length }} {{ batch.orders.length > 1 ? 'orders' : 'order' }} </span>
      @if (batch.numberOfPackages) {
        <span>{{ batch.numberOfPackages }} {{ batch.numberOfPackages > 1 ? 'packages' : 'package' }}</span>
      }
    </div>

    <!-- PICKUP -->
    <div class="batch-list-row__pickup customizable">
      @if (batch.pickupDate) {
        <div class="date">{{ batch.pickupDate | date: 'EEE, MMM d' }}</div>
      }
      @if (batch.shipFromAddress?.storeName) {
        <div class="location">From {{ batch.shipFromAddress?.storeName }}</div>
      }
    </div>

    <!-- FULFILLMENT STATUS -->
    <div>
      <batch-fulfillment-status-tag [batch]="batch"></batch-fulfillment-status-tag>
    </div>

    <!-- OWNER -->
    <batch-owner [batch]="batch"></batch-owner>

    <!-- LABEL STATUS -->
    <div class="batch-list-row__print-details">
      <span class="customizable">{{ batch.succeeded }}</span>
      @if (!isSecondary) {
        <span>/{{ batch.total }}</span>
      }
      <span class="customizable"> {{ batch.total > 1 ? 'labels' : 'label' }} generated</span>
      @if (batch.printCounter) {
        <p class="last">
          Printed {{ batch.printCounter }} times, last on
          {{ batch.lastPrint | date: 'MMM dd, hh:mmaaaa' }}
        </p>
      }
      @if (batch.failed) {
        <div class="batch-list-row__print-details__error">
          {{ displayBatchFailedText(batch.failed) }}
          <span
            class="error-tooltip"
            [matTooltip]="'Failed labels sent back to assign: ' + batch.failures"
            [matTooltipPosition]="'below'"
            matTooltipClass="pdq-mat-tooltip"
            >i</span
          >
        </div>
      }
    </div>

    <!-- PRINT BUTTON -->
    <div class="print">
      <pdq-dropdown
        [placeholder]="printPlaceholder"
        icon="print"
        align="right"
        [cta]="true"
        [useOverlay]="true"
        [sections]="printSections"
        [options]="printOptions"
        [disabled]="isTPL"
        type="actionList"
        (onChange)="print($event, batch.id)"
        (onOpen)="prepareLabels($event, batch.id)"></pdq-dropdown>
    </div>
  </div>
</div>
